import "../css/style.scss";

// Our modules / classes
import SiteBase from "./modules/SiteBase";
import MobileMenu from "./modules/MobileMenu";
// import HeroSlider from "./modules/HeroSlider";
import Accordion from "./modules/Accordion";
import ToScroll from "./modules/ToScroll";
// import StickyLinks from "./modules/StickyLinks";
// import StickyLinksCopy from "./modules/StickyLinks-copy";
import CopyLink from "./modules/CopyLink";
import Tab from "./modules/Tab";
import Panel from "./modules/Panel";
// import Loading from "./modules/Loading";
import MediumZoom from "./modules/MediumZoom";
// import CountDown from "./modules/CountDown";
// import Search from "./modules/Search";


// Instantiate a new object using our modules/classes
const siteBase = new SiteBase();
const mobileMenu = new MobileMenu();

// const frontHeroSlider = new HeroSlider('front-hero-slider',{
//   type: "carousel",
//   autoplay: 3000,
//   focusAt: 'center',
//   perView: 4.3,
//   gap: 0,
//   breakpoints: {
//     1400: {
//       perView: 3.5,
//     },
//     1000: {
//       perView: 2.2
//     },
//     800: {
//       perView: 1.8
//     },
//     600: {
//       perView: 1.108,
//     }
//   }
// }, 'front-hero-slider__bullets');


const accordion = new Accordion();
const toScroll = new ToScroll();
const copyLink = new CopyLink();
const tab = new Tab();
const panel = new Panel();
const mediumZoom = new MediumZoom();


